export function formatDate(dateStr) {
    if (!dateStr) return '';

    const adjustedDate = adjustTimeToSystemTimezone(dateStr); // Obtener fecha ajustada
    const date = new Date(adjustedDate.iso);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Los meses empiezan desde 0
    const year = date.getFullYear().toString().slice(-2); // Obtener últimos 2 dígitos del año
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function adjustTimeToSystemTimezone(dateString) {
    if (!dateString) return '';

    const localDate = new Date(dateString);  // Crea un objeto de fecha desde el string
    const timezoneOffset = localDate.getTimezoneOffset() * 60000;  // Obtener el offset en milisegundos
    const adjustedTime = new Date(localDate.getTime() - timezoneOffset);  // Ajustar a la zona horaria local

    // Crear las representaciones necesarias
    const isoString = adjustedTime.toISOString();  // Formato ISO ajustado
    const day = adjustedTime.getDate().toString().padStart(2, '0');
    const month = (adjustedTime.getMonth() + 1).toString().padStart(2, '0');
    const year = adjustedTime.getFullYear();

    const datePart = `${day}/${month}/${year}`;  // Fecha en formato local
    const timePart = adjustedTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });  // Hora en formato hh:mm

    return {
        iso: isoString,
        date: datePart,
        time: timePart
    };
}
